import Vue from 'vue'
import Resource from 'vue-resource'
import store from './store'
Vue.use(Resource)

export default {
	init () {
		if (window.localStorage) {
			if (store.state.user !== window.localStorage.getItem('user') && store.state.userAuth !== window.localStorage.getItem('user_auth')) {
				store.commit('SET_USER', JSON.parse(window.localStorage.getItem('user')))
				store.commit('SET_USER_AUTH', JSON.parse(window.localStorage.getItem('user_auth')))
			}
		}
		this.update()
	},
	update () {
		if (store.state.user !== null) {
			Vue.http.get(store.state.apiURL + '/v1/users/' + store.state.user.id + '?expand=photo', {}, {
			}).then(function (response) {
				var user = response.body
				store.commit('SET_USER', user)
				if (window.localStorage) {
					window.localStorage.setItem('user', JSON.stringify(user))
				}
			}, function (response) {
			})
		}
	},
	refresh () {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/oauth/refresh',
				{
					user_id: store.state.user.id,
					refresh_token: store.state.userAuth.refresh_token
				}).then(function (response) {
				/* eslint-disable */
				var data = response.body,
					userAuth = {
						access_token: data.access_token,
						expires_in: data.expires_in,
						token_type: data.token_type,
						refresh_token: data.refresh_token,
						refreshed_at: parseInt(new Date().getTime() / 1000)
					}
				store.commit('SET_USER_AUTH', userAuth)
				// Save to local storage as well
				if (window.localStorage) {
					window.localStorage.removeItem('user_auth')
					window.localStorage.setItem('user_auth', JSON.stringify(userAuth))
				}
				resolve(data)
			}, function (response) {
				reject(response)
			})
		})
	},
	isGuest () {
		return typeof window.localStorage.user === 'undefined' || typeof window.localStorage.user_auth === 'undefined'

	},
	logout () {
		store.commit('SET_USER', null)
		store.commit('SET_USER_AUTH', null)
		if (window.localStorage) {
			window.localStorage.removeItem('user')
			window.localStorage.removeItem('user_auth')
		}
		location.reload()
	}
}



// WEBPACK FOOTER //
// ./src/user.js